import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useUnreadMessages = () => {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchUnreadCount = async () => {
    if (!user) {
      setUnreadCount(0);
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase
        .from('messages')
        .select('id, is_read, receiver_id')
        .eq('receiver_id', user.id)
        .eq('is_read', false);

      if (error) {
        return;
      }

      const count = data?.length || 0;
      setUnreadCount(count);
    } catch (error) {
      // Silent error handling
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchUnreadCount();

      // Écouter les changements en temps réel
      const channel = supabase
        .channel('unread-messages')
        .on(
          'postgres_changes',
          {
            event: 'INSERT',
            schema: 'public',
            table: 'messages',
            filter: `receiver_id=eq.${user.id}`,
          },
          (payload) => {
            fetchUnreadCount();
          }
        )
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'messages',
            filter: `receiver_id=eq.${user.id}`,
          },
          (payload) => {
            fetchUnreadCount();
          }
        )
        .subscribe();

      // Fallback: vérifier périodiquement (toutes les 30 secondes)
      const interval = setInterval(() => {
        fetchUnreadCount();
      }, 30000);

      return () => {
        supabase.removeChannel(channel);
        clearInterval(interval);
      };
    } else {
      setUnreadCount(0);
      setLoading(false);
    }
  }, [user?.id]);

  return { unreadCount, loading, refetch: fetchUnreadCount };
};
